import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from 'src/shared/components/ui/sheet';

type VersionDrawerProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description?: string;
    children: React.ReactNode;
};

const VersionDrawer = ({ open, onOpenChange, title, description, children }: VersionDrawerProps) => {
    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent side='right' className='w-[420px] sm:max-w-[420px]'>
                <SheetHeader>
                    <SheetTitle>{title}</SheetTitle>
                    {description && <SheetDescription>{description}</SheetDescription>}
                </SheetHeader>
                <div className='mt-6'>{children}</div>
            </SheetContent>
        </Sheet>
    );
};

export default VersionDrawer;
